// gatsby-browser.js
import React from 'react'
import CookieNotice from './src/components/cookienotice'
import '@fortawesome/fontawesome-free/css/all.css'
export const wrapPageElement = ({ element }) => {
  return (
    <>
      {element}
      <CookieNotice />
    </>
  )
}